import React from "react";

const AmenitiesCard = () => {
  return (
    <div className="flex justify-center mt-4 font-sans">
      <div className="flex lg:flex-row flex-col  justify-center w-[90vw] px-3  bg-[#f1f1f1]  rounded-lg shadow-lg ">
        <div className="lg:lg:w-1/2 lg:border-r lg:border-black pr-4 flex flex-col py-2  justify-center">
          <h2 className="text-lg font-semibold mb-6 ml-2">
            Property Amenities
          </h2>
          <div className="mb-4 flex flex-row justify-center items-center">
            <div className="w-1/3 flex flex-col items-center">
              <ul className="text-[14px] text-left">
                <li>
                  <h3 className="text-[16px] font-semibold mb-4">Nearby</h3>
                </li>
                <li className="flex flex-row py-[6px]">
                  <img src="/map 1.svg"></img>
                  <h1 className="ml-2">Restaurant</h1>
                </li>
                <li className="flex flex-row py-[6px]">
                  <img src="/map 1.svg"></img>
                  <h1 className="ml-2">Grocery Store</h1>
                </li>
                <li className="flex flex-row py-[6px]">
                  <img src="/map 1.svg"></img>
                  <h1 className="ml-2">Park</h1>
                </li>
              </ul>
            </div>
            <div className="w-1/3 flex flex-col items-center">
              <ul className="text-[14px] text-left">
                <li>
                  <h3 className="text-[16px] font-semibold mb-4">Services</h3>
                </li>
                <li className="py-[6px]">Free Wi-Fi</li>
                <li className="py-[6px]">Room service</li>
                <li className="py-[6px]">24-hour reception</li>
              </ul>
            </div>
            <div className="w-1/3 flex flex-col items-center">
              <ul className="text-[14px] text-left">
                <li>
                  <h3 className="text-[16px] font-semibold mb-4">General</h3>
                </li>
                <li className="py-[6px]">Air conditioning</li>
                <li className="py-[6px]">Non-smoking rooms</li>
                <li className="py-[6px]">Family rooms</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="lg:w-1/2 ml-2 pr-4 flex flex-col py-2  justify-center">
          <h2 className="text-lg font-semibold mb-6 ml-2">Room Amenities</h2>
          <div className="mb-4 flex flex-row justify-center items-center">
            <div className="w-1/3 flex flex-col items-center">
              <ul className="text-[14px] text-left">
                <li>
                  <h3 className="text-[16px] font-semibold mb-4">Dining</h3>
                </li>
                <li className="py-[6px]">Restaurant</li>
                <li className="py-[6px]">Grocery store</li>
                <li className="py-[6px]">Park</li>
              </ul>
            </div>
            <div className="w-1/3 flex flex-col items-center">
              <ul className="text-[14px] text-left">
                <li>
                  <h3 className="text-[16px] font-semibold mb-4">Services</h3>
                </li>
                <li className="py-[6px]">Free Wi-Fi</li>
                <li className="py-[6px]">Room service</li>
                <li className="py-[6px]">24-hour reception</li>
              </ul>
            </div>
            <div className="w-1/3 flex flex-col items-center">
              <ul className="text-[14px] text-left">
                <li>
                  <h3 className="text-[16px] font-semibold mb-4">General</h3>
                </li>
                <li className="py-[6px]">Air conditioning</li>
                <li className="py-[6px]">Non-smoking rooms</li>
                <li className="py-[6px]">Family rooms</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmenitiesCard;
